/**
 * Canonical customer Accounts approved in Salesforce from Marc's commercial
 * pipeline. Keep these names identical across Salesforce, KCG Connect and Xero.
 * Add or rename customers in Salesforce first, then update this controlled list.
 */
export const SALESFORCE_ACCOUNT_OPTIONS = [
  'AMBASSADOR FOODS (PTY) A Division of Libstar',
  'Ambassador Food Theo Kleynhans',
  'Barakah Wholesalers',
  'Buttanutt',
  'CHAIRMANS TRADING',
  'Culinary, a Division of Tiger Consumer Brands Limited',
  'EASTERN TRADING COMPANY (PTY) LTD t/a Darsot Food Corporation',
  'Empire Foods',
  'GC Rieber Compact',
  'JKT FOODS TRADING BV',
  'KALINDA TRADING',
  'KALINDA TRADING (PTY) LTD',
  'MzansiGo South Africa (Pty) Ltd',
  'RCL GROUP SERVICES (PTY) LTD - GROCERY',
  'RE GROUNDNUTS (PTY) LTD',
  'Rialto, a Division of Libstar Operations (Pty) Ltd trading as Ambassador Foods',
  'SANDRE COMMODITIES (PTY) LTD',
  'THE PEANUT KING',
  'THOKOMAN FOODS (PTY) LTD',
  'THOKOMAN FOODS S.A. (PTY) LTD',
  'Tristar Investments Zambia LTD',
] as const

export function filterSalesforceAccounts(query: string): string[] {
  const normalized = query.trim().toLowerCase()
  const accounts = [...SALESFORCE_ACCOUNT_OPTIONS]
  if (!normalized) return accounts
  return accounts.filter((account) => account.toLowerCase().includes(normalized))
}

export function isSalesforceAccount(value: string): boolean {
  const normalized = value.trim().toLowerCase()
  return SALESFORCE_ACCOUNT_OPTIONS.some(
    (account) => account.toLowerCase() === normalized
  )
}
